import box from "../../../images/assetEquipmentTypes/box.png";
import card from "../../../images/assetEquipmentTypes/card.png";
import equipment from "../../../images/assetEquipmentTypes/equipment.png";
import film from "../../../images/assetEquipmentTypes/film.png";
import port from "../../../images/assetEquipmentTypes/port.png";
import relay from "../../../images/assetEquipmentTypes/relay.png";
import rj45 from "../../../images/assetEquipmentTypes/rj45.png";
import software from "../../../images/assetEquipmentTypes/software.png";
import software_exe from "../../../images/assetEquipmentTypes/software-exe.png";

export const equipmentIconsImageLookup = {
  box: box,
  card: card,
  equipment: equipment,
  film: film,
  port: port,
  relay: relay,
  rj45: rj45,
  software: software,
  "software-exe": software_exe,
};



// WEBPACK FOOTER //
// ./src/components/Common/EquipmentTree/images-index.js